// extracted by mini-css-extract-plugin
export default {"root":"InitialPageLoadingIndicator_root__nDo2F","logo":"InitialPageLoadingIndicator_logo__atiVY"};